import { Button } from '@/lib/base/buttons/button';
import { ObjectTypeConfigureStep } from '@/lib/vendor-import';

import type { HubspotImportObjectType } from './api';

const WORKSPACE_ADMIN_GUIDANCE =
  'HubSpot import is managed by your workspace admins. Ask an admin to enable it.';

function ImportUnavailableGuidance() {
  return (
    <p className='text-center text-body-small text-[var(--color-text-secondary)]'>
      {WORKSPACE_ADMIN_GUIDANCE}
    </p>
  );
}

export interface HubspotImportConfigureStepProps {
  objectTypes: HubspotImportObjectType[];
  isPending: boolean;
  isError: boolean;
  isForbidden: boolean;
  selected: string[];
  onChange: (names: string[]) => void;
  onRetry: () => void;
}

export function HubspotImportConfigureStep({
  objectTypes,
  isPending,
  isError,
  isForbidden,
  selected,
  onChange,
  onRetry,
}: HubspotImportConfigureStepProps) {
  // A 403 on either object-types or mapping-proposals means the workspace
  // isn't entitled to import. Show admin guidance rather than a retry the
  // user can never satisfy.
  if (isForbidden) {
    return <ImportUnavailableGuidance />;
  }
  if (isPending) {
    return (
      <p className='text-center text-body-small text-[var(--color-text-secondary)]'>
        Loading your HubSpot record types…
      </p>
    );
  }
  if (isError) {
    return (
      <div className='flex flex-col items-center gap-3'>
        <p className='text-center text-body-small text-[var(--color-text-error-primary)]'>
          We couldn't load your HubSpot record types. Check your connection and
          try again.
        </p>
        <Button size='sm' color='secondary' onClick={onRetry}>
          Retry
        </Button>
      </div>
    );
  }
  return (
    <ObjectTypeConfigureStep
      objectTypes={objectTypes}
      selected={selected}
      onChange={onChange}
      description='Choose which record types to bring over from HubSpot.'
    />
  );
}
